module.exports = __webpack_public_path__ + "static/media/instructivor3.ea44b5f1.png";